import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  sidebarReducer,
  themeReducer,
  authReducer,
  blogsReducer,
  draftsReducer,
  steemAccountReducer,
  modalsReducer,
  postsReducer,
  domainsReducer
} from '../../redux/reducers/index';
import thunk from 'redux-thunk';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducer = combineReducers({
  form: reduxFormReducer,
  theme: themeReducer,
  sidebar: sidebarReducer,
  domains: domainsReducer,
  auth: authReducer,
  blogs: blogsReducer,
  drafts: draftsReducer,
  posts: postsReducer,
  steemAccount: steemAccountReducer,
  modals: modalsReducer
});

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
